/**
 * 菜单项 → 权限操作 ID 映射
 *
 * 只映射在 PERMISSION_SECTIONS 中有明确权限定义的菜单项。
 * 未映射的菜单项默认对所有人可见（保持向后兼容）。
 */

/** 菜单项名称 → "查看"权限操作 ID */
export const MENU_VIEW_PERMISSION = {
  // ==================== 大屏 ====================
  '实时大屏': 'op_screen_realtime_view',
  '演示大屏': 'op_screen_demo_view',

  // ==================== 产品 ====================
  '设备/滤芯/配件': 'op_pl_view',
  '服务包产品': 'op_sb_view',
  '水量包产品': 'op_wp_view',
  '产品分类': 'op_pc_view',
  '产品系列': 'op_psr_view',
  '产品单位': 'op_pu_view',
  '设备电源功率管理': 'op_dpwr_view',
  '设备水箱容量管理': 'op_dtnk_view',
  '设备龙头组合管理': 'op_dfct_view',
  '产品标签': 'op_pt_view',
  '产品品牌': 'op_pb_view',
  '服务包权益': 'op_spb_view',
  '滤芯类型': 'op_ft_view',
  '产品规格': 'op_ps_view',

  // ==================== 订单 ====================
  '产品订单': 'op_ol_view',
  '服务包订单': 'op_osp_view',
  '服务包订单发货申请': 'op_oss_view',
  '销售出库单明细': 'op_osd_view',
  '充值订单': 'op_orr_view',
  '退换货订单': 'op_ort_view',
  '取消订单': 'op_ocr_view',
  '审批流程设置': 'op_oa_view',
  '订单设置': 'op_os_set_view',

  // ==================== 用户 ====================
  '用户列表': 'op_ul_view',
  '用户等级': 'op_ulv_view',
  '用户行业': 'op_uis_view',
  '用户标签': 'op_utg_view',
  '用户性质': 'op_upr_view',
  '用户来源渠道': 'op_usc_view',

  // ==================== 经销商 ====================
  '经销商列表': 'op_cl_view',
  '经销商解约管理': 'op_ct_view',
  '经销商等级': 'op_clv_view',
  '经销商权益': 'op_cbn_view',
  '经销商类别': 'op_ccg_view',
  '经销商来源渠道': 'op_csc_view',
  '经销商行业': 'op_cis_view',
  '经销商性质': 'op_cpr_view',

  // ==================== 报备 ====================
  '线索报备': 'op_lr_view',

  // ==================== 财务 ====================
  '资金账户': 'op_fa_view',
  '经销商充值申请': 'op_dr_view',
  '预扣款': 'op_pd_view',
  '资金流水': 'op_ff_view',
  '对账单': 'op_ms_view',
  '提现申请': 'op_wa_view',
  '发票': 'op_iv_view',

  // ==================== 售后工单 ====================
  '服务工单': 'op_sw_view',
  '售后申请管理': 'op_am_view',
  '投诉管理': 'op_cm_view',
  '工程师管理': 'op_eg_view',
  '工程师等级': 'op_el_view',
  '执行人管理': 'op_dp_view',
  '服务科目': 'op_sts_view',
  '工单标签': 'op_wt_view',
  '投诉类别管理': 'op_cc_view',
  '售后类别管理': 'op_ac_view',

  // ==================== 物联网 ====================
  '合约管理': 'op_id_view',
  '解约原因管理': 'op_tr_view',
  '设备管理': 'op_im_view',
  '协议查询': 'op_ip_view',
  '指令日志': 'op_il_view',

  // ==================== 经营报表 ====================
  '回款统计表': 'op_rpc_view',
  '装机统计表': 'op_ris_view',
  '销售统计表': 'op_rss_view',
  '员工统计表': 'op_res_view',
  '设备销售统计表': 'op_rdss_view',
  '运维统计表': 'op_ros_view',
  '租赁设备保有量分析': 'op_rld_view',
  '服务包保有量分析': 'op_rsp_view',
  '资金收支': 'op_rfi_view',

  // ==================== 系统设置 ====================
  '部门与员工': 'op_sd_view',
  '角色管理': 'op_sr_view',
  '员工管理': 'op_se_view',
  '账号管理': 'op_sa_view',
  '登录日志': 'op_sll_view',
  '操作日志': 'op_sol_view',
  '目标设置': 'op_et_view',
  '商城管理': 'op_sm_view',
  '区域管理': 'op_sar_view',
  '大区管理': 'op_la_view',
  '通知设置': 'op_ns_view',
  '其他设置': 'op_sot_view',
}

/**
 * 菜单项名称 → 任一权限列表（拥有其中之一即可见，优先于 MENU_VIEW_PERMISSION 判断）。
 * 用于按 tab / 子功能拆分了多个查看权限的整页菜单。
 */
export const MENU_ANY_VIEW_PERMISSION = {
  // 经销商分析表三 tab 拆分独立权限：消费统计 / 账户统计 / 经营状态
  '经销商分析表': ['op_rda_view', 'op_rpt_dealer_account_view', 'op_rpt_dealer_status_view'],
}

/** 路由路径 → "查看"权限操作 ID */
export const ROUTE_VIEW_PERMISSION = {
  // ==================== 大屏 ====================
  '/screen/realtime': 'op_screen_realtime_view',
  '/screen/demo': 'op_screen_demo_view',

  // ==================== 产品 ====================
  '/main/product/list': 'op_pl_view',
  '/main/product/add': 'op_pl_view',
  '/main/product/edit/:id': 'op_pl_view',
  '/main/product/workorder-price/:id': 'op_pl_view',
  '/main/product/link-device/:productId': 'op_pl_view',
  '/main/product/category': 'op_pc_view',
  '/main/product/series': 'op_psr_view',
  '/main/product/unit': 'op_pu_view',
  '/main/product/device-power-supply': 'op_dpwr_view',
  '/main/product/device-tank-capacity': 'op_dtnk_view',
  '/main/product/device-faucet-combo': 'op_dfct_view',
  '/main/product/tag': 'op_pt_view',
  '/main/product/brand': 'op_pb_view',
  '/main/product/service-package-benefit': 'op_spb_view',
  '/main/product/filter-type': 'op_ft_view',
  '/main/product/spec': 'op_ps_view',
  '/main/product/service-package/list': 'op_sb_view',
  '/main/product/service-package/add': 'op_sb_view',
  '/main/product/service-package/edit/:id': 'op_sb_view',
  '/main/product/water-package/list': 'op_wp_view',
  '/main/product/water-package/add': 'op_wp_add',
  '/main/product/water-package/edit/:id': 'op_wp_edit',
  '/main/product/water-package/detail/:id': 'op_wp_view',

  // ==================== 订单 ====================
  '/main/order/product/list': 'op_ol_view',
  '/main/order/product/add': 'op_ol_add',
  '/main/order/product/detail/:id': 'op_ol_view',
  '/main/order/product/edit/:id': 'op_ol_edit',
  '/main/order/bundle-product/list': 'op_ol_view',
  '/main/order/bundle-product/add': 'op_ol_edit',
  '/main/order/bundle-product/detail/:id': 'op_ol_view',
  '/main/order/bundle-product/edit/:id': 'op_ol_edit',
  '/main/order/lease-renewal/list': 'op_ol_view',
  '/main/order/lease-renewal/detail/:id': 'op_ol_view',
  '/main/order/service-package/list': 'op_osp_view',
  '/main/order/service-package/detail/:id': 'op_osp_view',
  '/main/order/sp-shipment-application/list': 'op_oss_view',
  '/main/order/sp-shipment-application/detail/:id': 'op_oss_view',
  '/main/order/sales-outbound/list': 'op_osd_view',
  '/main/order/sales-outbound/detail/:id': 'op_osd_view',
  '/main/order/recharge/list': 'op_orr_view',
  '/main/order/recharge/detail/:id': 'op_orr_view',
  '/main/order/after-sales-return/list': 'op_ort_view',
  '/main/order/after-sales-return/add': 'op_ort_add',
  '/main/order/after-sales-return/detail/:id': 'op_ort_view',
  '/main/order/cancel/list': 'op_ocr_view',
  '/main/order/cancel/detail/:id': 'op_ocr_view',
  '/main/order/approval-flow': 'op_oa_view',
  '/main/order/approval-flow/add': 'op_oa_view',
  '/main/order/approval-flow/edit/:id': 'op_oa_view',
  '/main/order/settings': 'op_os_set_view',

  // ==================== 用户 ====================
  '/main/user/list': 'op_ul_view',
  '/main/user/create': 'op_ul_view',
  '/main/user/edit/:id': 'op_ul_view',
  '/main/user/detail/:id': 'op_ul_view',
  '/main/user/level': 'op_ulv_view',
  '/main/user/industry': 'op_uis_view',
  '/main/user/tag': 'op_utg_view',
  '/main/user/property': 'op_upr_view',
  '/main/user/source-channel': 'op_usc_view',

  // ==================== 经销商 ====================
  '/main/channel/list': 'op_cl_view',
  '/main/channel/create': 'op_cl_view',
  '/main/channel/edit/:id': 'op_cl_view',
  '/main/channel/detail/:id': 'op_cl_view',
  '/main/channel/termination': 'op_ct_view',
  '/main/channel/level': 'op_clv_view',
  '/main/channel/benefit': 'op_cbn_view',
  '/main/channel/category': 'op_ccg_view',
  '/main/channel/source-channel': 'op_csc_view',
  '/main/channel/industry': 'op_cis_view',
  '/main/channel/property': 'op_cpr_view',

  // ==================== 报备 ====================
  '/main/report/lead': 'op_lr_view',

  // ==================== 财务 ====================
  '/main/finance/fund-account': 'op_fa_view',
  '/main/finance/dealer-recharge-application': 'op_dr_view',
  '/main/finance/pre-deduction': 'op_pd_view',
  '/main/finance/fund-flow': 'op_ff_view',
  '/main/finance/monthly-statement': 'op_ms_view',
  '/main/finance/withdrawal-application': 'op_wa_view',
  '/main/finance/invoice': 'op_iv_view',

  // ==================== 售后工单 ====================
  '/main/workorder/service': 'op_sw_view',
  '/main/workorder/service/detail/:id': 'op_sw_view',
  '/main/workorder/service/create': 'op_sw_view',
  '/main/workorder/service/edit/:id': 'op_sw_view',
  '/main/workorder/aftersales-manage': 'op_am_view',
  '/main/workorder/complaint-manage': 'op_cm_view',
  '/main/workorder/engineer': 'op_eg_view',
  '/main/workorder/engineer-level': 'op_el_view',
  '/main/workorder/dispatcher': 'op_dp_view',
  '/main/workorder/subject': 'op_sts_view',
  '/main/workorder/tag': 'op_wt_view',
  '/main/workorder/complaint-category': 'op_cc_view',
  '/main/workorder/aftersale-category': 'op_ac_view',

  // ==================== 物联网 ====================
  '/main/iot/contract': 'op_id_view',
  '/main/iot/contract/detail/:id': 'op_id_view',
  '/main/iot/termination-reason': 'op_tr_view',
  '/main/iot/device': 'op_im_view',
  '/main/iot/device/detail/:id': 'op_im_view',
  '/main/iot/protocol': 'op_ip_view',
  '/main/iot/log': 'op_il_view',

  // ==================== 经营报表 ====================
  '/main/report/v2/payment-collection': 'op_rpc_view',
  '/main/report/v2/installation-stats': 'op_ris_view',
  '/main/report/v2/sales-stats': 'op_rss_view',
  '/main/report/v2/employee-stats': 'op_res_view',
  '/main/report/v2/device-sales-stats': 'op_rdss_view',
  '/main/report/v2/ops-statistics': 'op_ros_view',
  '/main/report/v2/lease-device-stock': 'op_rld_view',
  '/main/report/v2/service-pack-stock': 'op_rsp_view',
  '/main/report/fund-income-expenditure': 'op_rfi_view',

  // ==================== 系统设置 ====================
  '/main/system/department': 'op_sd_view',
  '/main/system/role': 'op_sr_view',
  '/main/system/role/:id/permission': 'op_sr_view',
  '/main/system/account': 'op_sa_view',
  '/main/system/employee': 'op_se_view',
  '/main/system/employee/target': 'op_sd_target',
  '/main/system/login-log': 'op_sll_view',
  '/main/system/operation-log': 'op_sol_view',
  '/main/system/target-settings': 'op_et_view',
  '/main/system/area': 'op_sar_view',
  '/main/system/large-area': 'op_la_view',
  '/main/system/other-settings': 'op_sot_view',
  '/main/system/message-list': 'op_ns_view',
  '/main/system/message-config': 'op_ns_view',
}

/**
 * 通用订单详情在跳转时无法确定订单类型，拥有任一订单查看权限即可访问。
 */
export const ROUTE_ANY_VIEW_PERMISSION = {
  '/main/order/detail/:orderId': [
    'op_ol_view',
    'op_osp_view',
    'op_oss_view',
    'op_osd_view',
    'op_orr_view',
    'op_ort_view',
    'op_ocr_view',
  ],
  // 合约创建向导：新增（op_id_add）、续租/续约（op_id_renew）、编辑（op_id_edit）、
  // 订单列表「创建合约」入口（op_ol_create_contract）均可进入；提交接口后端同样按任一校验
  '/main/iot/contract/create': [
    'op_id_add',
    'op_id_edit',
    'op_id_renew',
    'op_ol_create_contract',
  ],
  // 移除合约设备页：仅编辑权限可进入（提交接口同样校验 op_id_edit）
  '/main/iot/contract/remove-device/:id': [
    'op_id_edit',
  ],
  // 经销商分析表：三 tab 查看权限任一即可进入整页（tab 内再按各自权限显隐）
  '/main/report/v2/dealer-analysis': [
    'op_rda_view',
    'op_rpt_dealer_account_view',
    'op_rpt_dealer_status_view',
  ],
}

/**
 * 获取当前登录用户的权限 ID 列表。
 * @returns {string[]}
 */
export function getUserPermissionIds() {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return []
    const user = JSON.parse(raw)
    return user.permissionIds || []
  } catch {
    return []
  }
}

/**
 * 检查用户是否拥有指定菜单的查看权限。
 * 未映射的菜单项默认返回 true。
 * @param {string} menuItemName
 * @param {string[]} [permIds]
 * @returns {boolean}
 */
export function canViewMenuItem(menuItemName, permIds) {
  const ids = permIds || getUserPermissionIds()
  const anyRequired = MENU_ANY_VIEW_PERMISSION[menuItemName]
  if (anyRequired) return anyRequired.some(permission => ids.includes(permission))
  const required = MENU_VIEW_PERMISSION[menuItemName]
  if (!required) return true
  return ids.includes(required)
}

/**
 * 检查用户是否拥有访问指定路由的权限。
 * 未映射的路由默认返回 true。
 * @param {string} routePath
 * @param {string[]} [permIds]
 * @returns {boolean}
 */
export function canAccessRoute(routePath, permIds) {
  const findMatchedPermission = permissionMap => permissionMap[routePath]
    || Object.entries(permissionMap).find(([pattern]) => {
      const expression = '^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$'
      return new RegExp(expression).test(routePath)
    })?.[1]

  const required = findMatchedPermission(ROUTE_VIEW_PERMISSION)
  const anyRequired = findMatchedPermission(ROUTE_ANY_VIEW_PERMISSION)
  if (!required && !anyRequired) return true
  const ids = permIds || getUserPermissionIds()
  return required ? ids.includes(required) : anyRequired.some(permission => ids.includes(permission))
}

export function hasPermission(permissionId, permIds) {
  const ids = permIds || getUserPermissionIds()
  return ids.includes(permissionId)
}

/**
 * 订单 selfOnly：后端对非制单人行返回 selfOperable=false。
 * 未返回该字段时不额外限制（后端仍会拒绝写操作）。
 */
export function orderRowOperable(row) {
  return !row || row.selfOperable !== false
}

/** 首页 Tab key → “查看”权限操作 ID（Dashboard.vue 页签独立控制） */
export const DASHBOARD_TAB_VIEW_PERMISSION = {
  lease: 'op_hd_lease_view',
  performance: 'op_hd_perf_view',
  dealer: 'op_hd_dealer_view',
  afterSales: 'op_hd_after_view',
  user: 'op_hd_user_view',
  core: 'op_hd_core_view',
}

/**
 * 检查用户是否拥有指定首页 Tab 的查看权限。
 * 未映射的 Tab 默认返回 true（向后兼容）。
 * @param {string} tabKey
 * @param {string[]} [permIds]
 * @returns {boolean}
 */
export function canViewDashboardTab(tabKey, permIds) {
  const required = DASHBOARD_TAB_VIEW_PERMISSION[tabKey]
  if (!required) return true
  const ids = permIds || getUserPermissionIds()
  return ids.includes(required)
}

/**
 * 获取首个有权限的首页 Tab key，无任何权限时返回空字符串。
 * @param {Array<{key:string}>} tabs
 * @param {string[]} [permIds]
 * @returns {string}
 */
export function getFirstAccessibleDashboardTab(tabs, permIds) {
  const ids = permIds || getUserPermissionIds()
  const hit = (tabs || []).find(t => canViewDashboardTab(t.key, ids))
  return hit ? hit.key : ''
}
